import { Link } from "react-router-dom";
import { MapPin, Ticket, Clock } from "lucide-react";
import { media } from "@/lib/api";

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
const DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
export const dateParts = (s) => { const [y, m, d] = s.split("-").map(Number); return { day: d, month: MONTHS[m - 1], dow: DAYS[new Date(y, m - 1, d).getDay()] }; };
export const mapsUrl = (e) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([e.venue, e.address, e.city].filter(Boolean).join(", "))}`;

export const DateBadge = ({ date, className = "" }) => {
  const p = dateParts(date);
  return (
    <div className={`flex w-16 shrink-0 flex-col items-center rounded-xl border border-[#FF2E63]/40 bg-[#FF2E63]/10 py-2 ${className}`}>
      <span className="font-mono text-[10px] tracking-widest text-[#FF2E63]">{p.dow}</span>
      <span className="font-display text-3xl font-black leading-none">{p.day}</span>
      <span className="font-mono text-[10px] tracking-widest text-slate-400">{p.month}</span>
    </div>
  );
};

export const EventRow = ({ e, showArtist }) => (
  <div className="group flex gap-4 border-b border-white/5 py-5" data-testid={`event-${e.id}`}>
    <DateBadge date={e.date} />
    <div className="min-w-0 flex-1 space-y-1.5">
      {showArtist && <Link to={`/a/${e.artist.slug}`} className="font-mono text-[11px] uppercase tracking-widest text-[#00F5D4]">{e.artist.stage_name}</Link>}
      <div className="font-display text-lg font-bold leading-tight">{e.title}</div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-slate-400">
        {e.time && <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{e.time}</span>}
        <a href={mapsUrl(e)} target="_blank" rel="noreferrer" className="flex items-center gap-1 hover:text-white" data-testid={`event-map-${e.id}`}><MapPin className="h-3.5 w-3.5" />{e.venue} · {e.city}</a>
        {e.price && <span className="text-[#FFB800]">{e.price}</span>}
      </div>
      {e.address && <div className="text-xs text-slate-500">{e.address}</div>}
      {e.info && <p className="whitespace-pre-line pt-1 text-sm text-slate-300">{e.info}</p>}
      {e.ticket_url && <a href={e.ticket_url} target="_blank" rel="noreferrer" className="btn-hot mt-2 !px-4 !py-1.5 text-xs" data-testid={`event-tickets-${e.id}`}><Ticket className="h-3.5 w-3.5" />Tickets</a>}
    </div>
    {e.poster && <a href={media(e.poster)} target="_blank" rel="noreferrer" className="hidden h-28 w-20 shrink-0 overflow-hidden rounded-lg border border-white/10 sm:block"><img src={media(e.poster)} alt="" className="h-full w-full object-cover" /></a>}
  </div>
);

export const EventCard = ({ e }) => (
  <Link to={`/a/${e.artist.slug}`} className="panel group relative flex w-72 shrink-0 snap-start flex-col overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-testid={`home-event-${e.id}`}>
    <div className="relative h-40 overflow-hidden bg-[#07090E]">
      {(e.poster || e.artist.photo) && <img src={media(e.poster || e.artist.photo)} alt="" className="h-full w-full object-cover opacity-80 transition-transform duration-500 group-hover:scale-105" />}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1420] to-transparent" />
      <DateBadge date={e.date} className="absolute left-3 top-3 bg-[#07090E]/80 backdrop-blur" />
    </div>
    <div className="space-y-1 p-4">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#00F5D4]">{e.artist.stage_name}</div>
      <div className="line-clamp-2 font-display text-lg font-bold leading-tight">{e.title}</div>
      <div className="flex items-center gap-1 text-sm text-slate-400"><MapPin className="h-3.5 w-3.5 shrink-0" /><span className="truncate">{e.venue} · {e.city}</span></div>
      <div className="font-mono text-xs text-slate-500">{e.time && `${e.time} · `}{e.price}</div>
    </div>
  </Link>
);
